/* eslint @typescript-eslint/strict-boolean-expressions: off */

import cn from "classnames";
import React from "react";
import styles from "gui/subtitle/subtitle.module.css";
import { Icon } from "gui/icon/icon";

export const Subtitle: React.FC<{
  as?: string;
  icon?: string;
  id?: string;
  className?: string;
  text: React.ReactNode;
}> = (props) => {
  const as = props.as ?? "h2";

  const className = cn(
    styles.subtitle,
    props.icon && styles.icon,
    props.className
  );

  const heading = React.createElement(
    as,
    { className: styles.text, id: props.id },
    props.icon && <Icon icon={props.icon} />,
    props.text
  );

  return (
    <header className={className}>
      {heading}
      <div className={styles.spacer} aria-hidden />
      {props.children}
    </header>
  );
};
